
import ExtraObjects from "../Pages/Extraobjects/Extra_Objects";
import AddExtraObjectForm from "../Pages/Extraobjects/Add_ExtraObjetcts";
import { Navigate } from "react-router";


const role=localStorage.getItem("role")
export const ExtraobjetRoutes = [
  {
    path: 'ExtraObjects',
    element: <ExtraObjects />
  },
  {
    path: '/AddExtraObjectForm',
    element: role !== 'manager' ? <Navigate to="/ExtraObjects" replace /> : <AddExtraObjectForm />
  },
  {
    path: '/AddExtraObjectForm/:id',
    element: role !== 'manager' ? <Navigate to="/ExtraObjects" replace /> : <AddExtraObjectForm />
  },
];
